const symbol = '&bull;'

export const loaderAnimTemplate = `<span class="loader__dot">${symbol}</span><span class="loader__dot">${symbol}</span><span class="loader__dot">${symbol}</span>`

export default function (element) {
    $(element).html(loaderAnimTemplate)
}